'use strict';

angular.module('ecrd.states')
    .component('partialHistory', {
        templateUrl: 'modules/states/components/partial-history/template.html',
        controller: 'PartialHistoryController',
        bindings: {
            state: '<',
            changes: '<',
            formId: '<',
        },
    });
